<div class="aems-bread-crumb m-b-16">
  <a class="m-r-4" routerLink="/master-data">Master Data</a><span>/ {{ 'Contract Rates & Discounts' }}</span>
  @if (showOemDiscountBreadcrumb) {
    <span class="m-r-4">/ </span><a class="m-r-4" routerLink="/master-data/shop-contract/oem-discount">OEM Discount</a>
    @if (oemDiscountBreadcrumbLabel) {
      <span>/ {{ oemDiscountBreadcrumbLabel }}</span>
    }
  }
</div>
<h3 #top class="m-b-12">{{ 'Contract Rates & Discounts' }}</h3>
<div class="pure-g">
  <div class="pure-u-md-24-24 pure-u-lg-24-24 pure-u-xl-24-24">
    <mc-tab-bar [currentindex]="currentIndex$ | async">
      <mc-tab slot="tab"><a routerLink="material-rates" routerLinkActive="mds-tree-nav__active">Material Rates</a></mc-tab>
      <mc-tab slot="tab"><a routerLink="labour-rates" routerLinkActive="mds-tree-nav__active">Labour Rates</a></mc-tab>
      @if (authPolicies.canViewOemDiscount) {
        <mc-tab slot="tab"><a routerLink="oem-discount" routerLinkActive="mds-tree-nav__active">OEM Discount</a></mc-tab>
      }
    </mc-tab-bar>
  </div>
</div>
<div class="content-container">
  <router-outlet></router-outlet>
</div>
